"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A class which encapsulates components of a Pay ID.
 */
class PayIdComponents {
    /**
     * Create a new PayIdComponents.
     *
     * @param host - The host of the payment pointer.
     * @param path - The path of the payment pointer, starting with a leading '/'.
     */
    constructor(host, path) {
        this.host = host;
        this.path = path;
    }
}
exports.default = PayIdComponents;
//# sourceMappingURL=pay-id-components.js.map